import persistor from './persistor';

export default function keycloakInit({ cookies, config }) {
    const { publicRuntimeConfig: { keycloak } } = config;
    const keycloakConfig = {
        realm: keycloak.realm,
        url: keycloak.authServerUrl,
        clientId: keycloak.clientId,
    };
    const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';

    persistor.setCookies(cookies);
    const { initialLoginFlow, refreshToken, idToken } = persistor.getTokens();

    let checkLoginIframe = false;
    if (refreshToken && !initialLoginFlow) checkLoginIframe = true;

    const initOptions = {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: initialLoginFlow ? false : `${origin}/silent-check-sso.html`,
        silentCheckSsoFallback: false,
        redirectUri: origin,
        checkLoginIframe,
        refreshToken,
        idToken,
        enableLogging: true,
    };

    return { keycloakConfig, persistor, initOptions };
}
